/**
 * useVisibility.tsx
 */
import AnalyticsInstance from "@shared/utils/analytics";
import { PlayerState } from "@shared/types/enums/player";
import { appSelector } from "@shared/store/slices/app.slice";
import { mediaSelector, pause, play } from "@shared/store/slices/media.slice";
import { useAppDispatch, useAppSelector } from "@shared/store/hooks";
import { useEffect, useRef } from "react";

// Check app visibility and clear stack or reset content

export default function useVisibility() {
  const dispatch = useAppDispatch();
  const { state } = useAppSelector(mediaSelector);
  const {
    status: { visibility },
  } = useAppSelector(appSelector);
  const paused = useRef(false);

  useEffect(() => {
    if (!visibility) {
      paused.current = state === PlayerState.PAUSE;
      AnalyticsInstance.getOmnitrackManager()?.setAppToBackground();
      dispatch(pause());
    } else {
      AnalyticsInstance.getOmnitrackManager()?.setAppToForeground();
      if (!paused.current) dispatch(play());
    }
  }, [visibility]);

  return null;
}
